import { keyStatus } from '@/config/Workspace'

export const readFileAsync = (file) => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader()

    reader.onload = () => {
      resolve(reader.result)
    }

    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}

export const convertFileToItem = (steps, file) => {
  let r = { key: file.key }
  steps.forEach(config => {
    r[config.name] = keyStatus(config, file)
  })
  return r
}

export const sorter = (a, b) => {
  if (a === undefined || b === undefined) {
    if (a === b) return 0
    else return a === undefined ? 1 : -1
  } else if (typeof a === 'string') {
    return a.localeCompare(b)
  } else if (typeof a === 'number') {
    return a - b
  } else {
    throw new Error('not supported sorting type.')
  }
}

export const accessor = (item, path) => {
  let segs = path.split('/')
  if (segs.length >= 3) { segs = [segs[0], segs[1], segs.slice(2).join('/')] }
  for (const prop of segs) {
    if (!item.hasOwnProperty(prop)) {
      return undefined
    }
    item = item[prop]
  }
  return item
}
